
<!-- <app-ibfgrid></app-ibfgrid> -->

<app-loader></app-loader>
    <router-outlet></router-outlet>

